import {Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoursServices } from '../services/cours.services';
import { HttpClient } from '@angular/common/http';
import {Tuto} from '../tuto/tuto';

export interface ElementCoordinates {
  x: number;
  y: number;
  width: number;
  height: number;
  top: number;
  right: number;
  bottom: number;
  left: number;
}

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [CommonModule, Tuto],
  templateUrl: './test.html',
  styleUrl: './test.css',
})
export class Test {
  profs: any[] = [];

  constructor(
    private coursServices: CoursServices,
  ) {}


  loadCourses(): void {
    this.coursServices.getProfs().subscribe({
      next: (data) => {
        this.profs = data.elements;
        console.log('data load :', this.profs);
      },
      error: (err) => {
        console.error('Error loading courses:', err);
      }
    });
  }

}
